import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nService } from '../common/service/i18n.service';
import { CommonsModule } from '../common/commons.module';
import { PlatformComponent } from './components/platform/platform.component';
import { PLATFORM_START_I18N_ENTRIES } from './i18n/platform-start-i18n-entries';
import { PlatformStartComponent } from './components/platform-start/platform-start.component';
import { DemoComponent } from './components/demo/demo.component';
import { DEMO_I18N_ENTRIES } from './i18n/demo-i18n-entries';
import { FaqsComponent } from './components/faqs/faqs.component';
import { RecordComponent } from './components/record/record.component';
import { PwaMetricsComponent } from './components/pwa-metrics/pwa-metrics.component';
import { RECORD_I18N_ENTRIES } from './i18n/record-i18n-entries';
import { FAQS_I18N_ENTRIES } from './i18n/faqs-i18n-entries';



@NgModule({
  declarations: [
    PlatformComponent,
    PlatformStartComponent,
    DemoComponent,
    FaqsComponent,
    RecordComponent,
    PwaMetricsComponent
  ],
  imports: [
    CommonModule,
    CommonsModule
  ],
})
export class PlatformModule {
  constructor(
    private i18nService: I18nService
  ) {
    i18nService.addI18nEntriesObject(PLATFORM_START_I18N_ENTRIES);
    i18nService.addI18nEntriesObject(DEMO_I18N_ENTRIES);
    i18nService.addI18nEntriesObject(RECORD_I18N_ENTRIES);
    i18nService.addI18nEntriesObject(FAQS_I18N_ENTRIES);
  }
}
